import isMobile from './isMobile';

window.addEventListener('DOMContentLoaded', () => {
  const titleArea = document.querySelector('.title-area');
  if (!titleArea) {
    return;
  }

  const updateHeightVar = (height) => {
    if (titleArea.querySelector('.questionnaire') && isMobile()) {
      console.log('fff')
      titleArea.querySelector('.title-area__overlay').style.setProperty('--title-area-max-height', `calc(var(--header-height) + var(--spacer-large) + ${height}px)`);
    } else if (titleArea.querySelector('.title-area__content-bottom')) {
      titleArea.querySelector('.title-area__overlay').style.setProperty('--title-area-max-height', `calc(var(--header-height) + ${height}px)`);
    }

  };

  updateHeightVar(titleArea.getBoundingClientRect().height);

  const resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
      updateHeightVar(entry.contentRect.height);
    }
  });
  resizeObserver.observe(titleArea);
});
